<div class="top-line-row">
  <div *ngFor="let item of scorecardTopOne" class="card">
    <div class="custom-card-header">
      <div class="title">{{ item.title }}</div>
      <div class="subtitle">{{ item.value }}</div>
    </div>
    <div class="metric-wrap">
      <ng-container *ngIf="item.color === 'red'">
        <div style="width: 10px; height: 10px;" class="red feedback"></div>
      </ng-container>
      <ng-container *ngIf="item.color === 'green'">
        <div style="width: 10px; height: 10px;" class="green feedback"></div>
      </ng-container>
      {{ item.markMessage }}
    </div>
  </div>
</div>

<div class="card-wrap">
  <div class="card" *ngFor="let section of scorecard.criteria; let i = index">
      <div class="custom-eval-card-header" [style]="{'font-size': print ? '14px' : ''}">
        <div class="title">{{ section.sectionTitle }}</div>
        <div class="performance-chip">{{ section.passedCriteriaCount }} / {{ section.totalCriteriaCount }}</div>
      </div>
      <app-call-details-eval-card-row
        *ngFor="let i2 of section.criteria"
        [evalPoint]="i2"
        [print]="print"
        (click)="onEvalRowClick({ sectionTitle: section.sectionTitle, criterion: i2.criterion })"
        style="cursor: pointer;"
      ></app-call-details-eval-card-row>
  </div>
</div>
